import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import { useTheme } from '../../contexts/ThemeContext';

const ProfileSettingsModal = ({ isOpen, onClose, onOpenDeleteModal }) => {
  const { theme, setLightMode, setDarkMode } = useTheme();

  if (!isOpen) return null;

  const handleThemeSelect = (selectedTheme) => {
    if (selectedTheme === 'light') {
      setLightMode();
    } else {
      setDarkMode();
    }
  };

  const handleDeleteAccount = () => {
    onClose();
    onOpenDeleteModal();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-surface border border-border rounded-lg shadow-xl max-w-lg w-full mx-4 max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-xl font-semibold text-text-primary">Profile Settings</h2>
          <button
            onClick={onClose}
            className="text-text-secondary hover:text-text-primary transition-colors"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} color="currentColor" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Appearance Section */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-3">Appearance</h3>
            <div className="flex space-x-3">
              <button
                onClick={() => handleThemeSelect('light')}
                className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-lg border-2 transition-all ${
                  theme === 'light' ?'border-primary bg-primary/10 text-primary' :'border-border bg-background text-text-secondary hover:border-border hover:bg-muted'
                }`}
              >
                <Icon name="Sun" size={18} color="currentColor" />
                <span className="font-medium">Light</span>
              </button>
              <button
                onClick={() => handleThemeSelect('dark')}
                className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-lg border-2 transition-all ${
                  theme === 'dark' ?'border-primary bg-primary/10 text-primary' :'border-border bg-background text-text-secondary hover:border-border hover:bg-muted'
                }`}
              >
                <Icon name="Moon" size={18} color="currentColor" />
                <span className="font-medium">Dark</span>
              </button>
            </div>
          </div>

          {/* Account Section */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-3">Account</h3>
            <div className="bg-error/10 border border-error/20 rounded-lg p-4 mb-3">
              <p className="text-sm text-text-secondary">
                Deleting your account permanently removes all data. Export reports first.
              </p>
            </div>
            <Button
              variant="destructive"
              onClick={handleDeleteAccount}
              className="w-full bg-error hover:bg-error/90 text-white"
            >
              <Icon name="Trash2" size={16} color="currentColor" className="mr-2" />
              Delete Account
            </Button>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end p-6 border-t border-border">
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfileSettingsModal;